/**
 * Whether the send flow needs the extracted-files step (drop PDF/XML + match employees).
 * @param {object} format
 */
export function sendDrawerNeedsExtractedRecipients(format) {
  if (!format) return false;
  if (format.type === 'xml') return true;
  // One combined PDF split by page: must run extraction so each row has pageNum (no template-only DM).
  if (format.type === 'single-pdf') return true;
  return Array.isArray(format.items) && format.items.length > 0;
}

/**
 * Step keys for the document-format send drawer.
 * @param {object|null|undefined} format
 * @param {{ allowFormatSelection?: boolean }} options When false (e.g. Send from template row), per-send with extraction skips DocumentMode.
 * @returns {('DocumentMode'|'SetupDocument'|'DataMapping'|'ExtractedRecipients'|'Recipients'|'Message'|'Send')[]}
 */
export function getSendDrawerStepKeys(format, options = {}) {
  const keys = [];
  /** Generic "Send" from tracking / toolbar: start on document & mode. */
  if (options.allowFormatSelection) {
    keys.push('DocumentMode');
  } else if (format && format.documentSource === 'per-send') {
    /** Row send: per-send without extraction needs session PDF here; with extraction, PDF is on ExtractedRecipients. */
    if (!sendDrawerNeedsExtractedRecipients(format)) {
      keys.push('DocumentMode');
    }
  }
  if (!format) return keys;

  const needsExtractedRecipients = sendDrawerNeedsExtractedRecipients(format);

  if (needsExtractedRecipients) {
    /** Placement / XML mapping before bulk upload & extraction (recipient rows). */
    if (format.type === 'xml') {
      keys.push('DataMapping');
    } else {
      keys.push('SetupDocument');
    }
    keys.push('ExtractedRecipients');
  } else {
    keys.push('Recipients');
    if (format.type === 'xml') {
      keys.push('DataMapping');
    } else {
      keys.push('SetupDocument');
    }
  }

  keys.push('Message', 'Send');
  return keys;
}
